import React from 'react'
import { Message } from 'mage-i18n'
import { SpacerVertical, TitleSecondary } from 'mage-deps/@klarna/bubble-ui'
import ContactButton from '../ContactButton'
import { useEducationFeature } from 'education-tools'
import SupportButton from '../SupportButton'

export default function SearchSupportButton() {
  const isSupportCenterActive = useEducationFeature('meg.merchant-support-center')

  return (
    <>
      <TitleSecondary>
        <Message path="hqm.search.results.contact" fallback="Can't find the help you need?" />
      </TitleSecondary>
      <SpacerVertical small />
      {isSupportCenterActive && <SupportButton analyticsCategory="uhqm/support-button/search" />}
      {!isSupportCenterActive && <ContactButton analyticsCategory="uhqm/contact-button/search" />}
      <SpacerVertical medium />
    </>
  )
}
